import React from 'react';
import { toast as sonner } from 'sonner';
import AiToast from '../components/AiToast';

// Drop-in replacement for sonner's `toast`: same call sites
// (toast.success/error/message/info/warning), AI-native rendering. Pass
// { agent, confidence, description } in the options to enrich a notification.
const show = (kind, message, opts = {}) => {
  const { description, agent, confidence, duration, id, ...rest } = opts;
  return sonner.custom(
    (tid) => (
      <AiToast id={tid} kind={kind} message={message} description={description} agent={agent} confidence={confidence} />
    ),
    { duration: duration ?? (kind === 'error' ? 6000 : 4000), unstyled: true, id, ...rest },
  );
};

export const toast = {
  success: (m, o) => show('success', m, o),
  error: (m, o) => show('error', m, o),
  message: (m, o) => show('agent', m, o),
  info: (m, o) => show('info', m, o),
  warning: (m, o) => show('warning', m, o),
  loading: (m, o) => show('working', m, o),
  working: (m, o) => show('working', m, o),
  // explicit agent attribution: toast.agent('Verification', 'Cleared check', { confidence: 0.96 })
  agent: (agent, m, o = {}) => show('agent', m, { ...o, agent }),
  custom: (...a) => sonner.custom(...a),
  promise: (...a) => sonner.promise(...a),
  dismiss: (...a) => sonner.dismiss(...a),
};

export default toast;
